import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import styles from './styles.scss';

import {
  Button,
  IpadStandard,
  Clockin,
} from '../../../../../../shared';

import messages from '../../i18n';

export class Confirm extends PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);

    this.state = {
      clockinDisappear: false,
    };
  }

  handleClick() {
    this.setState({ clockinDisappear: true });
    setTimeout(() => {
      window.open(this.props.magicLink || 'https://my.tanda.co/login', '_blank');
      this.props.signUpRecordConversion();
    }, 550);
  }

  render() {
    return (
      <div className={styles.Confirm}>
        <div>
          <div className={styles.imageContainer}>
            <Clockin
              className={cn(styles.clockin, this.state.clockinDisappear ? styles.disappear : null)}
            />
            <IpadStandard className={styles.tablet} />
          </div>

          <div className={styles.textContainer}>
            <div className={styles.heading}>
              <FormattedMessage {...messages.loginToTandaHeading} />
            </div>
            <div className={styles.body}>
              <FormattedMessage {...messages.loginToTandaBody} />
            </div>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <Button className={cn('green', styles.seeMyTimesheetButton)} onClick={this.handleClick}>
            <FormattedMessage {...messages.seeMyTimesheet} />
          </Button>
          <div
            onClick={this.props.clearUser}
            className={cn('charcoal', styles.link)}
          >
            <p>
              <FormattedMessage {...messages.keepClockingIn} />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

Confirm.propTypes = {
  magicLink: PropTypes.string,
  signUpRecordConversion: PropTypes.func,
  clearUser: PropTypes.func,
};

export default connect(state => ({
  magicLink: state.getIn(['config', 'magicLink']),
}))(Confirm);



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/home/ClockIn/FirstClockIn/Confirm/index.jsx